/* eslint-disable no-unused-vars */

import HomePage from '../views/HomePage.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/giftcode',
    name: 'Giftcode',
    component: () => import('../views/Giftcode.vue'),
    children: [
      {
        path: '/giftcode',
        name: 'AllGiftcode',
        component: () => import('../views/AllGiftcode.vue'),
      },
      {
        path: '/giftcode/exchange-code',
        name: 'ExchangeCode',
        component: () => import('../views/ExchangeCode.vue'),
      },
      {
        path: '/giftcode/:id',
        name: 'GiftcodeDetail',
        component: () => import('../views/GiftcodeDetail.vue'),
      },
    ],
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/Support.vue'),
  },
  {
    path: '/napvgplay',
    beforeEnter() {
      window.open('https://nap.vgplay.vn')
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
